import React from 'react';

const CustomAlertModal = ({ show, message, onHide }) => {
  if (!show) return null;

  return (
    <div className="modal-backdrop-custom d-flex justify-content-center align-items-center" style={{
      position: 'fixed',
      top: 0, left: 0, width: '100vw', height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      zIndex: 9999
    }}>
      <div className="bg-white rounded p-4 shadow-lg text-center" style={{ maxWidth: '400px', width: '90%' }}>
        <p className="mb-4 text-dark fw-semibold fs-5" style={{ whiteSpace: 'pre-wrap' }}>{message}</p>
        <button className="btn btn-primary-custom px-4 py-2 fw-bold w-100" onClick={onHide}>
          OK
        </button>
      </div>
    </div>
  );
};

export default CustomAlertModal;
